import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import {
    getDeviceResults,
    searchCmdbDevices,
    searchCmdbAdvanced,
} from './devices'
import { getCustomerResults, searchCustomer } from './customers'
import { getCmdbClasses, searchCmdbClass } from './misc'

const CI = 'ci'
const CMDB_CLASS = 'cmdb_class'
const CUSTOMER = 'customer'
// const CONFIGURATION = 'configuration'
// const RESOLVER_GROUP = 'resolver_group'

export default createReducer(
    {
        byId: {
            [CI]: {
                id: CI,
                name: 'CI Number',
                values: [],
                dbValue: 'hinumber',
            },
            [CMDB_CLASS]: {
                id: CMDB_CLASS,
                name: 'CMDB Class',
                values: [],
                dbValue: 'class',
            },
            [CUSTOMER]: {
                id: CUSTOMER,
                name: 'Organization',
                values: [],
                dbValue: 'organization_cgkprimarykey',
            },
            // [CONFIGURATION]: {id: CONFIGURATION, name: 'Configuration', values: []},
            // [RESOLVER_GROUP]: {id: RESOLVER_GROUP, name: 'Resolver Group', values: []},
        },
        values: [
            CUSTOMER,
            CMDB_CLASS,
            CI,
            // CONFIGURATION, RESOLVER_GROUP
        ],
        selected: CUSTOMER,
        loading: false,
    },
    {
        [actions.SELECT_CMDB_CI_FILTER]: (state, action) => {
            return {
                ...state,
                selected: action.payload.filterId,
                loading: false,
            }
        },
        [actions.SELECT_CMDB_FILTER_VALUE]: (state, action) => {
            const filterId = action.payload.filterId
            const filter = state.byId[filterId]
            const values = action.payload.values
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [filterId]: {
                        ...filter,
                        values,
                    },
                },
            }
        },
    }
)

export const getFilters = (state) =>
    state.cmdb.filters.values.map((f) => state.cmdb.filters.byId[f])

export const getFilterById = (state, filterId) =>
    state.cmdb.filters.byId[filterId]

export const getResultsForFilter = (state) => {
    const { selected } = state.cmdb.filters
    switch (selected) {
        case CI:
            return getDeviceResults(state)
        case CUSTOMER:
            return getCustomerResults(state)
        case CMDB_CLASS:
            return getCmdbClasses(state)
        default:
            return null
    }
}

export const getLoadingForFilter = (state) => {
    const { selected } = state.cmdb.filters
    switch (selected) {
        case CI:
            return state.cmdb.devices.loading
        case CUSTOMER:
            return state.cmdb.customers.loading
        case CMDB_CLASS:
            return state.cmdb.misc.cmdbClassLoading
        default:
            return null
    }
}

export const selectFilter = (filter) => ({
    type: actions.SELECT_CMDB_CI_FILTER,
    payload: {
        filterId: filter.id,
    },
})

export const searchFilter = (query) => (dispatch, getState) => {
    const { selected } = getState().cmdb.filters
    switch (selected) {
        case CI:
            return dispatch(searchCmdbDevices(query))
        case CUSTOMER:
            return dispatch(searchCustomer(query))
        case CMDB_CLASS:
            return dispatch(searchCmdbClass(query))
        default:
            return null
    }
}

export const setFilterValue = (filterId, values) => (dispatch) => {
    dispatch({
        type: actions.SELECT_CMDB_FILTER_VALUE,
        payload: { values, filterId },
    })
    dispatch(searchFilteredDevices())
}

export const searchFilteredDevices = () => (dispatch, getState) => {
    let state = getState()
    const filters = getFilters(state)
    const result = {}
    for (let id in filters) {
        let { dbValue, values } = filters[id]
        if (values.length) {
            result[dbValue] = values
        }
    }
    dispatch(searchCmdbAdvanced(result))
}
